import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [filter, setFilter] = useState("all");
  useEffect(() => { axios.get(`${API}/admin/leads`).then((r) => setLeads(r.data)); }, []);

  const filtered = filter === "all" ? leads : leads.filter((l) => l.source === filter);
  const sources = ["all", "popup", "newsletter", "design_upload", "whatsapp_click"];

  return (
    <div className="fade-in" data-testid="admin-leads-page">
      <div className="mb-10">
        <div className="font-micro text-[#8A8680] mb-3">Concierge</div>
        <h1 className="font-serif text-[#EDE4D3] text-5xl">Leads Inbox.</h1>
      </div>

      <div className="flex gap-3 mb-8">
        {sources.map((s) => (
          <button key={s} className={`chip ${filter === s ? "active" : ""}`} onClick={() => setFilter(s)} data-testid={`admin-lead-filter-${s}`}>{s.replace("_", " ")}</button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="p-10 text-center font-serif text-[#8A8680] text-2xl" style={{ background: "#141414", border: "1px solid var(--hairline)" }}>
          No leads.
        </div>
      ) : (
        <div className="space-y-3" data-testid="admin-leads-list">
          {filtered.map((l) => (
            <div key={l.id} className="p-6 grid grid-cols-5 gap-4" style={{ background: "#141414", border: "1px solid var(--hairline)" }}>
              <div>
                <div className="font-micro text-[#8A8680] mb-1">Name</div>
                <div className="font-serif text-[#EDE4D3]">{l.name || "—"}</div>
              </div>
              <div>
                <div className="font-micro text-[#8A8680] mb-1">Phone / Email</div>
                <div className="text-[#EDE4D3]">{l.phone || l.email || "—"}</div>
              </div>
              <div>
                <div className="font-micro text-[#8A8680] mb-1">Room</div>
                <div className="text-[#D8D6D1]">{l.room_of_interest || "—"}</div>
              </div>
              <div>
                <div className="font-micro text-[#8A8680] mb-1">Source</div>
                <div className="text-[#B8895C] font-micro">{l.source}</div>
              </div>
              <div className="font-micro text-[#8A8680] text-right">{l.created_at?.slice(0, 16).replace("T", " ")}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
